

    if (window.Sentry) {
      window.Sentry.init({ dsn: "https://244597332e474a0cae62fe5bcd78439f@sentry.wixpress.com/2364", environment: 'Editor' });
    }
  

    import React from 'react';
    import ReactDOM from 'react-dom';
    import { withStyles } from '@wix/native-components-infra';
    import EditorAppWrapper from '@wix/yoshi-flow-editor/runtime/esm/EditorAppWrapper.js';
    import Widget from '/home/builduser/work/65272e1ccdb126e5/packages/express-checkout-widget-ooi/src/components/ExpressCheckoutWidget/Widget/index.tsx';
    import createController from '/home/builduser/work/65272e1ccdb126e5/packages/express-checkout-widget-ooi/src/components/ExpressCheckoutWidget/controller.ts';

    
import { createHttpClient } from '@wix/yoshi-flow-editor/runtime/esm/controller/httpClientProp';
    

    
var initI18n = null;

    

    var createExperiments = null;
    var createWidgetExperiments = null;
    

    
import { createRavenClient } from '@wix/yoshi-flow-editor/error-monitor';
    import Raven from '@wix/yoshi-flow-editor/raven-js';
    var createErrorMonitor = function(options) {
      return createRavenClient({
        Raven,
        ...options,
      });
    };
    

    
var I18nextProvider = React.Fragment;


    var PureExperimentsProvider = React.Fragment;
    var ExperimentsProvider = React.Fragment;
    

import { BILoggerProvider } from '@wix/yoshi-flow-editor/runtime/esm/react/BILogger/BILoggerProvider';

import { FedopsLoggerProvider } from '@wix/yoshi-flow-editor/runtime/esm/react/FedopsLoggerProvider';

import { HttpProvider } from '@wix/yoshi-flow-editor';

  import { TPAComponentsProvider } from 'wix-ui-tpa/TPAComponentsConfig';

var BaseUiEnvironmentProviderWrapper = React.Fragment;

var providers = {
  I18nextProvider,
  ExperimentsProvider,
  PureExperimentsProvider,
  BILoggerProvider,
  FedopsLoggerProvider,
  HttpProvider,
  TPAComponentsProvider,
  BaseUiEnvironmentProviderWrapper,
}

    import * as fedopsLogger from '@wix/yoshi-flow-editor/fedops';

    
  var importedApp = {};

    var componentName = 'ExpressCheckoutWidget';
    var projectName = 'express-checkout-widget-ooi';
    var sentryConfig = {
      DSN: 'https://244597332e474a0cae62fe5bcd78439f@sentry.wixpress.com/2364',
      id: '244597332e474a0cae62fe5bcd78439f',
      projectName: 'express-checkout-widget-ooi',
      teamName: 'payments',
      errorMonitor: true,
    };
    import stylesParams from '/home/builduser/work/65272e1ccdb126e5/packages/express-checkout-widget-ooi/src/components/ExpressCheckoutWidget/stylesParams.ts';
    var experimentsConfig = null;
    var fedopsConfig = null;
    var translationsConfig = {"enabled":false,"icuEnabled":true};
    var defaultTranslations = null;
    var biConfig = null;
    var appDefinitionId = "47e245ca-1a42-4d6a-a69a-c125bc839b40";
    var componentId = "54fb025c-61dc-4286-87c7-0ac416c58744";
    var isUsingAppSettings = false;
    var localeDistPath = 'assets/locales';
    var persistentAcrossPages = false;
    var shouldUseEssentials = true;
    var shouldSkipMultipleRendersAfterViewModeChange = false;
    var withErrorBoundary = false;

    import { createVisitorBILogger as biLogger } from '/home/builduser/work/65272e1ccdb126e5/packages/express-checkout-widget-ooi/target/generated/bi/createBILogger.ts';
    
      import { hot } from '@wix/component-hot-loader';
      var UserComponent = hot(module, Widget);
    

    var EditorComponent = React.createElement(EditorAppWrapper, {
      UserComponent,
      appDefinitionId,
      componentId,
      isUsingAppSettings,
      name: componentName,
      sentryConfig: sentryConfig,
      experimentsConfig: experimentsConfig,
      fedopsConfig: fedopsConfig,
      translationsConfig: translationsConfig,
      defaultTranslations: defaultTranslations,
      shouldUseEssentials,
      persistentAcrossPages,
      projectName: projectName,
      biConfig: biConfig,
      biLogger: biLogger,
      stylesParams,
      withErrorBoundary,
      shouldSkipMultipleRendersAfterViewModeChange,
      userController: createController,
      customInitAppForPage: importedApp.initAppForPage,
      optionalDeps: {
        initI18n,
        fedopsLogger,
        withStylesHoc: withStyles,
        createHttpClient,
        createExperiments,
        createWidgetExperiments,
        createErrorMonitor,
        providers,
      },
      localeDistPath: localeDistPath,
    });
    ReactDOM.render(EditorComponent, document.getElementById('root'));
